<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  * {
    padding: 0;
    margin: 0;
  }

  #app {
    /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px; */
    overflow: hidden;
  }

  input::-webkit-input-placeholder,
  textarea::-webkit-input-placeholder {
    color: #B3B3B3;
    font-size: 16px;
  }

  input:-moz-placeholder,
  textarea:-moz-placeholder {
    color: #B3B3B3;
    font-size: 16px;
  }

  input::-moz-placeholder,
  textarea::-moz-placeholder {
    color: #B3B3B3;
    font-size: 16px;
  }

  input:-ms-input-placeholder,
  textarea:-ms-input-placeholder {
    color: #B3B3B3;
    font-size: 16px;
  }

  input {
    font-size: 16px;
    border: none;
    outline: none;
  }

  /* 适用于 Chrome、Safari、Edge、Opera */
  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* 适用于 Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue